import { browserHelpers, routerHelpers } from '@approvalmax/utils';
import { useQuery } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { useMount } from 'react-use';
import { routingService } from 'services/routing';
import { getPath, Path } from 'urlBuilder';

import { loadOneRequest, loadPageData, showOperationResultPopup } from '../actions';
import { MOBILE_DECISION_PAGE_ID, QueryKeys } from '../config';
import { OperationResult } from '../reducers/page/activePopup/operationResultPopupReducer';

const useMobileDecisionPageData = () => {
    const dispatch = useDispatch();
    const location = useLocation();
    const activeRequestId = routerHelpers.getParamAsString(location.search, 'requestId', '');
    const companyId = routerHelpers.getParamAsString(location.search, 'companyId', '');
    const isMobile = browserHelpers.isMobile();

    useMount(() => {
        if (isMobile && !activeRequestId) {
            routingService.push(getPath(Path.mobile));
        }
    });

    const { isInitialLoading } = useQuery(
        [QueryKeys.MobileDecisionPageData, activeRequestId],
        async () => {
            const requestData = await loadOneRequest(activeRequestId, companyId);

            return requestData;
        },
        {
            enabled: isMobile,
            onSuccess: (requestData) => {
                if (requestData) {
                    dispatch(
                        loadPageData({
                            filter: null,
                            companyId: null,
                            templateId: null,
                            requestId: activeRequestId,
                            requests: [],
                            hasMore: false,
                            entities: requestData.entities,
                            innerPageId: MOBILE_DECISION_PAGE_ID,
                        })
                    );
                } else {
                    dispatch(showOperationResultPopup(activeRequestId, null, OperationResult.FailedRequestNotFound));
                }
            },
            onError: () => {
                dispatch(
                    loadPageData({
                        filter: null,
                        companyId: null,
                        templateId: null,
                        requestId: activeRequestId,
                        requests: [],
                        hasMore: false,
                        entities: {},
                        innerPageId: MOBILE_DECISION_PAGE_ID,
                    })
                );
                dispatch(showOperationResultPopup(activeRequestId, null, OperationResult.FailedRequestNotFound));
            },
        }
    );

    return {
        isInitialLoading,
    };
};

export default useMobileDecisionPageData;
